module.exports = __webpack_public_path__ + "img/gala-competencies.14dd8127.svg";